import React from 'react';

const NotFound = () => {
    return ( 
        <div className='not-found text-center d-flex vh-100 justify-content-center align-items-center flex-column'>
            <h2 className='fw-bold fs-3 my-4'>404 - Not Found</h2>
            <p className='fs-5 fw-bold'>The page you are looking for does not exist.</p>
        </div>
    );
}

export default NotFound;